import { Configuration } from "../models/Configuration";

export const EAKTYWNI_TERMS_URL = "https://eaktywni.pl/regulamin/";

export const TTPAY_NAME = "TT Pay sp. z o.o.";
export const TTPAY_ADDRESS = "ul. Przemysłowa 9A, 35-105 Rzeszów";
export const TTPAY_KRS = "0001156710";
export const TTPAY_NIP = "8133928981";
export const TTPAY_KNF_REGISTER = "MIP277/2025";
export const TTPAY_INFRASTRUCTURE = "PayU";

export const TTPAY_TERMS_URL =
  "https://cdn.prod.website-files.com/673ad1bb83b86d7bcd81ba0f/6a2a4816b837094aa0aad427_Regulamin%20TT%20Pay.pdf";
export const TTPAY_PRIVACY_URL =
  "https://cdn.prod.website-files.com/673ad1bb83b86d7bcd81ba0f/6a2a48167b964da4ae493a42_Polityka%20prywatnosci%20TT%20Pay.pdf";

export const TTPAY_FOOTER_ANCHOR_ID = "ttpay-payment-info";

export const TTPAY_I18N_VALUES = {
  name: TTPAY_NAME,
  address: TTPAY_ADDRESS,
  krs: TTPAY_KRS,
  nip: TTPAY_NIP,
  knf: TTPAY_KNF_REGISTER,
  infrastructure: TTPAY_INFRASTRUCTURE,
};

export function isTTPayEnabled(configuration?: Pick<Configuration, "showTermsAsTTPay">): boolean {
  return Boolean(configuration?.showTermsAsTTPay);
}

export function getEAktywniTermsUrl(configuration?: Pick<Configuration, "showTermsAsTTPay">): string {
  return isTTPayEnabled(configuration) ? TTPAY_TERMS_URL : EAKTYWNI_TERMS_URL;
}
